(() => {
  // app/scripts/infinite-load.js
  customElements.define("infinite-loading", class extends HTMLElement {
    constructor() {
      super();
      this.submitBtn = this.querySelector("button");
      this.submitBtn.addEventListener("click", e => {
        this.fetch();
      });
    }
    fetch() {
      const url = this.dataset.url;
      this.loading();
      fetch(url).then(e => e.text()).then(e => {
        var _document$querySelect;
        this.parentNode.remove();
        const div = document.createElement("div");
        div.innerHTML = e;
        const containerClassName = this.dataset.container.includes(".") ? this.dataset.container : "#" + this.dataset.container;
        const container = document.querySelector(containerClassName);
        container.innerHTML += div.querySelector(containerClassName).innerHTML;
        (_document$querySelect = document.querySelectorAll(".jsFilterUpdate")) === null || _document$querySelect === void 0 || _document$querySelect.forEach(item => {
          const newItem = div.querySelector(`[class="${item.className}"]`);
          if (!newItem) return;
          item.innerHTML = newItem.innerHTML;
        });
      });
    }
    loading() {
      this.classList.add("loading");
      if (!this.submitBtn.querySelector(".icon-loading")) {
        var _document$querySelect2;
        this.svgLoading = (_document$querySelect2 = document.querySelector("#svg_loading svg")) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.cloneNode(true);
        this.svgLoading.id = "loadingSVG";
        this.submitBtn.insertAdjacentElement("afterbegin", this.svgLoading);
      }
      this.submitBtn.toggleAttribute("disabled", true);
    }
  });
})();
